import fetch from '@/utils/fetch'
// 登录（测试）
export function login(username, password) {
  return fetch({
    url: '/login',
    method: 'post',
    data: {
      username:username,
      password,
      device_type: 'pc',
      client_terminal_type: 'web',
      type: 'account'
    }
  })
}
// 客户端获取有效的接口访问凭据
export function getClientTempticket(clientId) {
  return fetch({
    url: '/client/tempticket?clientid=' + clientId,
    method: 'get',
  })
}
// Web登录（正式）
export function webLogin(data) {
  return fetch({
    url: '/user/weblogin?tempticket=' + data.tempticket,
    method: 'post',
    data: data.jsonData
  })
}
// 获取用户信息
export function userInfo() {
  return fetch({
    url: '/userinfo',
    method: 'get',
  })
}
// 登出
export function logout() {
  return fetch({
    url: '/logout',
    method: 'get'
  })
}
// 验证token是否有效
export function checkToken() {
  return fetch({
    url: '/check/token',
    method: 'get'
  })
}
// web端刷新token
export function refreshToken(data) {
  return fetch({
    url: '/user/webrefresh/token?clientid=' + data.clientid,
    method: 'post',
    data: {
      refresh_token: data.refresh_token
    }
  })
}

/**
 * 第三方登录web端
 */

// PC客户端跳转Web端 
// Web端验证用户临时令牌(第三步))(第一、二步由PC端完成)
export function checkTempToken(params) {
  return fetch({
    url: '/check/temp/token/' + params.temp_token,
    method: 'get',
    params: {
      clientid: params.clientid
    }
  })
}



